module.exports = __webpack_public_path__ + "static/gold_badge-439d78f125130aa1a288b6f11199d2d4.png";